(function () {
    const DURATION = 1800; // ms
    const EASE = (t) => 1 - Math.pow(1 - t, 3); // ease-out cubic

    function parseValue(raw) {
        // split into: prefix (non-digit), number (inc. decimals), suffix (non-digit)
        const match = raw.match(/^([^0-9]*)([0-9,]+(?:\.[0-9]+)?)([^0-9]*)$/);
        if (!match) return null;
        return {
            prefix: match[1],
            number: parseFloat(match[2].replace(/,/g, '')),
            suffix: match[3],
            formatted: match[2],
            decimals: (match[2].split('.')[1] || '').length,
        };
    }

    function formatNumber(value, parsed) {
        const hasCommas = parsed.formatted.includes(',');
        const fixed = value.toFixed(parsed.decimals);
        if (!hasCommas || parsed.decimals > 0) return fixed;
        return Math.round(value).toLocaleString('en-US');
    }

    function animateStat(dt) {
        const raw = dt.textContent.trim();
        const parsed = parseValue(raw);
        if (!parsed || parsed.number === 0) return;

        const start = performance.now();

        function tick(now) {
            const elapsed = now - start;
            const t = Math.min(elapsed / DURATION, 1);
            const current = EASE(t) * parsed.number;
            dt.textContent = parsed.prefix + formatNumber(current, parsed) + parsed.suffix;
            if (t < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
    }

    function init() {
        const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        document.querySelectorAll('.wp-block-pulp-stats').forEach((block) => {
            const stats = block.querySelectorAll('.stats-list .stat dt');
            if (!stats.length) return;

            if (isReduced) return; // respect user preference

            const observer = new IntersectionObserver(
                (entries, obs) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return;
                        obs.unobserve(entry.target);
                        entry.target.querySelectorAll('.stat dt').forEach(animateStat);
                    });
                },
                { threshold: 0.2 }
            );

            observer.observe(block);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
